let held = 0;
let queue = [];

export const holdGameToasts = () => {
    held += 1;
};

export const releaseGameToasts = () => {
    held = Math.max(0, held - 1);
    if (held > 0) return;
    const pending = queue;
    queue = [];
    pending.forEach(show => {
        try { show(); } catch (err) { console.error('[TOAST GATE] Queued toast failed:', err); }
    });
};

export const resetGameToasts = () => {
    held = 0;
    queue = [];
};

export const gateToast = (show) => {
    if (held > 0) queue.push(show);
    else show();
};
